/*
 * Mysbox pricing page (templates/page.pricing-mb.json).
 * The "Compare the plans" and "Estimate your cost" sections are two separate sections
 * shown one at a time, like tabs. Each marks its panel with data-mbp-view and
 * data-mbp-tab-label; this script builds the tab bar into every [data-mbp-tabs] and
 * switches panels. The estimator reads plan prices from the plans section
 * (script[data-mbp-plans]), so prices live in one place.
 */
(function () {
  if (window.mbpPricing) return;

  var nf = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  var ni = new Intl.NumberFormat('en-US');
  function money(c) { return '$' + nf.format(c / 100); }
  function int(n) { return ni.format(n); }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* ---------- Tabs: one visible panel among [data-mbp-view] ---------- */

  function panels() { return Array.prototype.slice.call(document.querySelectorAll('[data-mbp-view]')); }

  function show(view, scroll) {
    var list = panels(), target = null;
    list.forEach(function (p) {
      var on = p.getAttribute('data-mbp-view') === view;
      p.hidden = !on;
      if (on) target = p;
    });
    if (!target) return;
    document.querySelectorAll('[data-mbp-tab]').forEach(function (t) {
      var on = t.getAttribute('data-mbp-tab') === view;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    if (scroll) window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 16, behavior: 'smooth' });
  }

  function buildTabs() {
    var list = panels();
    document.querySelectorAll('[data-mbp-tabs]').forEach(function (bar) {
      bar.innerHTML = '';
      if (list.length < 2) { bar.hidden = true; return; }
      bar.hidden = false;
      list.forEach(function (p, i) {
        var view = p.getAttribute('data-mbp-view');
        var b = el('button', 'mbp-tab', p.getAttribute('data-mbp-tab-label') || view);
        b.type = 'button';
        b.setAttribute('role', 'tab');
        b.setAttribute('data-mbp-tab', view);
        b.setAttribute('aria-controls', p.id);
        b.setAttribute('aria-selected', p.hidden ? 'false' : 'true');
        b.tabIndex = p.hidden ? -1 : 0;
        b.addEventListener('click', function () { show(view, true); });
        b.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var next = list[(i + (e.key === 'ArrowRight' ? 1 : list.length - 1)) % list.length].getAttribute('data-mbp-view');
          show(next, false);
          var btn = bar.querySelector('[data-mbp-tab="' + next + '"]');
          if (btn) btn.focus();
        });
        bar.appendChild(b);
      });
    });
    // With only one panel on the page (the other section removed or disabled), always show it.
    if (list.length === 1) list[0].hidden = false;
    else if (!list.some(function (p) { return !p.hidden; }) && list.length) show(list[0].getAttribute('data-mbp-view'), false);
  }

  // "#estimator" links anywhere on the page (hero, FAQ) open the estimator; data-mbp-go opens a named view.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#estimator"], a[href$="#pricing"], [data-mbp-go]');
    if (!a) return;
    var view = a.getAttribute('data-mbp-go') || (/#estimator$/.test(a.getAttribute('href') || '') ? 'estimate' : 'compare');
    if (!document.querySelector('[data-mbp-view="' + view + '"]')) return;
    e.preventDefault();
    show(view, true);
  });

  /* ---------- Feature tooltips ---------- */

  function initTips(root) {
    root.querySelectorAll('[data-mbp-tip]').forEach(function (btn) {
      if (btn.dataset.mbpReady) return;
      btn.dataset.mbpReady = '1';
      var tip = document.getElementById(btn.getAttribute('aria-describedby'));
      if (!tip) return;
      function set(open) { tip.hidden = !open; }
      btn.addEventListener('mouseenter', function () { set(true); });
      btn.addEventListener('mouseleave', function () { set(false); });
      btn.addEventListener('focus', function () { set(true); });
      btn.addEventListener('blur', function () { set(false); });
      btn.addEventListener('click', function () { set(tip.hidden); });
    });
  }

  /* ---------- FAQ: one question open at a time (data-mbp-single-open) ---------- */

  function initFaq(root) {
    root.querySelectorAll('[data-mbp-single-open]').forEach(function (list) {
      var seen = false;
      list.querySelectorAll('details').forEach(function (d) {
        if (d.open && seen) d.open = false;
        if (d.open) seen = true;
      });
    });
  }
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.open || !d.matches || !d.matches('[data-mbp-single-open] > details')) return;
    d.parentNode.querySelectorAll(':scope > details[open]').forEach(function (o) { if (o !== d) o.open = false; });
  }, true);

  /* ---------- Estimator ---------- */

  function readPlans() {
    var node = document.querySelector('script[data-mbp-plans]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent).map(function (p) {
        return { name: p.name, accent: p.accent, link: p.link, quota: p.quota, stopsAtQuota: p.stopsAtQuota,
          baseC: Math.round(parseFloat(String(p.price).replace(/[^0-9.]/g, '') || '0') * 100) };
      });
    } catch (err) { return null; }
  }

  function readPrice(raw) {
    var s = String(raw).replace(/[^0-9.]/g, '');
    if (s === '') return { empty: true };
    if ((s.match(/\./g) || []).length > 1 || isNaN(parseFloat(s))) return { err: 'Enter the price as a number.' };
    var v = parseFloat(s);
    if (v > 10000) return { err: 'This estimator goes up to $10,000 a box. Selling above that, book a call and we will work it out with you.' };
    return { value: v };
  }
  function readVolume(raw) {
    var s = String(raw).replace(/[^0-9.]/g, '');
    if (s === '') return { empty: true };
    if (s.indexOf('.') !== -1) return { err: 'Enter a whole number of boxes.' };
    var v = parseInt(s, 10);
    if (isNaN(v)) return { err: 'Enter a whole number of boxes.' };
    if (v > 1000000) return { err: 'This estimator goes up to 1,000,000 boxes a month. Above that, book a call and we will work it out with you.' };
    return { value: v };
  }
  function compute(plans, price, volume, minC, pct) {
    var perBoxC = Math.max(minC, Math.round(price * pct * 100));
    var rows = plans.map(function (p) {
      var usesUsage = !p.stopsAtQuota;
      var eligible = usesUsage || volume <= p.quota;
      var billable = Math.max(0, volume - p.quota);
      return { plan: p, eligible: eligible, billable: billable, usesUsage: usesUsage, totalC: p.baseC + (usesUsage ? billable * perBoxC : 0) };
    });
    var w = null;
    rows.forEach(function (r) {
      if (!r.eligible) return;
      if (!w || r.totalC < w.totalC || (r.totalC === w.totalC && r.plan.baseC < w.plan.baseC)) w = r;
    });
    return { perBoxC: perBoxC, rows: rows, winner: w };
  }

  function initEstimator(root) {
    if (root.dataset.mbpReady) return;
    root.dataset.mbpReady = '1';
    var minC = parseInt(root.getAttribute('data-min-cents'), 10) || 25;
    var pctNum = parseFloat(root.getAttribute('data-usage-percent')) || 2;
    var pct = pctNum / 100;
    var btnLabel = root.getAttribute('data-button-label') || '';
    var btnLink = root.getAttribute('data-button-link') || '#';
    var inputs = { price: root.querySelector('[data-mbp-input="price"]'), volume: root.querySelector('[data-mbp-input="volume"]') };
    var out = {};
    root.querySelectorAll('[data-mbp-out]').forEach(function (n) { out[n.getAttribute('data-mbp-out')] = n; });
    var selected = null; // plan name the merchant clicked; falls back to the cheapest plan

    function setError(name, msg) {
      var field = root.querySelector('[data-mbp-field="' + name + '"]');
      var n = root.querySelector('[data-mbp-error="' + name + '"]');
      field.classList.toggle('has-error', !!msg);
      n.textContent = msg || '';
      n.hidden = !msg;
      inputs[name].setAttribute('aria-invalid', msg ? 'true' : 'false');
    }
    function cell(cls, label, text) {
      var c = el('span', cls, text);
      c.setAttribute('role', 'cell');
      c.setAttribute('data-label', label);
      return c;
    }

    function render() {
      var plans = readPlans();
      out.rows.innerHTML = '';
      if (!plans || !plans.length) {
        out.rows.appendChild(el('p', 'mbp-est__missing', 'Add the "Mysbox pricing: plans" section to this page so the estimator knows the plans.'));
        return;
      }
      var pr = readPrice(inputs.price.value), vr = readVolume(inputs.volume.value);
      setError('price', pr.err); setError('volume', vr.err);
      // Above the largest plan quota: suggest a custom plan.
      if (out.custom) {
        var topQuota = Math.max.apply(null, plans.map(function (p) { return p.quota; }));
        out.custom.hidden = !!vr.err || vr.empty || vr.value <= topQuota;
      }
      if (pr.err || vr.err) return;
      // An empty field counts as 0 in the maths but stays empty on screen.
      var price = pr.empty ? 0 : pr.value, volume = vr.empty ? 0 : vr.value;
      var res = compute(plans, price, volume, minC, pct), cheapest = res.winner;
      var sel = res.rows.filter(function (r) { return r.eligible && r.plan.name === selected; })[0] || cheapest;

      res.rows.forEach(function (x) {
        var usage = x.usesUsage ? x.billable * res.perBoxC : 0;
        var extra = !x.eligible ? '—' : (usage > 0 ? int(x.billable) + ' × ' + money(res.perBoxC) + ' = ' + money(usage) : money(0));
        var row = el('div', 'mbp-est__row' + (x === sel ? ' is-selected' : '') + (!x.eligible ? ' is-na' : ''));
        row.setAttribute('role', 'row');
        var name = el('span', 'mbp-est__plan');
        name.setAttribute('role', 'rowheader');
        name.appendChild(el('span', 'mbp-est__plan-name', x.plan.name));
        if (x === cheapest) name.appendChild(el('span', 'mbp-cost__pill', 'Cheapest'));
        row.appendChild(name);
        row.appendChild(cell(null, 'Plan fee', money(x.plan.baseC)));
        row.appendChild(cell(null, 'Included boxes', x.plan.stopsAtQuota ? 'Up to ' + int(x.plan.quota) : int(x.plan.quota)));
        row.appendChild(cell(null, 'Extra boxes cost', extra));
        row.appendChild(cell('mbp-est__total', 'Total / month', x.eligible ? money(x.totalC) : 'Not available'));
        if (x.eligible) {
          row.tabIndex = 0;
          row.setAttribute('aria-selected', x === sel ? 'true' : 'false');
          var pick = function () { selected = x.plan.name; render(); var again = out.rows.querySelector('.is-selected'); if (again) again.focus(); };
          row.addEventListener('click', pick);
          row.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
        } else {
          row.setAttribute('aria-disabled', 'true');
        }
        out.rows.appendChild(row);
      });

      var selUsage = sel.usesUsage ? sel.billable * res.perBoxC : 0;
      out.context.textContent = sel === cheapest ? 'Cheapest plan for you' : money(sel.totalC - cheapest.totalC) + ' more than ' + cheapest.plan.name;
      out.plan.textContent = sel.plan.name;
      out.total.textContent = money(sel.totalC);
      out.fee.textContent = money(sel.plan.baseC);
      out.extra.textContent = int(sel.usesUsage ? sel.billable : 0) + ' extra × ' + money(res.perBoxC);
      out.usage.textContent = money(selUsage);
      if (out.cta) {
        // The shared button prints its label twice (rolling hover): update both lines, not the whole anchor.
        var ctaText = btnLabel + ' with ' + sel.plan.name;
        var ctaLines = out.cta.querySelectorAll('.qk-btn__roll > span');
        if (ctaLines.length) { ctaLines.forEach(function (n) { n.textContent = ctaText; }); } else { out.cta.textContent = ctaText; }
        out.cta.href = sel.plan.link || btnLink;
      }
    }

    ['price', 'volume'].forEach(function (name) {
      inputs[name].addEventListener('input', function () {
        var clean = this.value.replace(/[^0-9.]/g, '');
        if (clean !== this.value) this.value = clean;
        render();
      });
    });
    root.mbpRender = render;
    render();
  }

  function init() {
    buildTabs();
    initTips(document);
    initFaq(document);
    document.querySelectorAll('[data-mbp-estimator]').forEach(initEstimator);
    if (location.hash === '#estimator') show('estimate', false);
  }

  window.mbpPricing = { init: init, show: show };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: re-init after a section reloads, and reveal the panel being edited.
  document.addEventListener('shopify:section:load', function () {
    init();
    document.querySelectorAll('[data-mbp-estimator]').forEach(function (r) { if (r.mbpRender) r.mbpRender(); });
  });
  document.addEventListener('shopify:section:select', function (e) {
    var p = e.target.querySelector('[data-mbp-view]');
    if (p) show(p.getAttribute('data-mbp-view'), false);
  });
})();
